import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./functionsLanding.scss";
import { useNavigate } from "react-router-dom";

// Import your images (make sure these paths are correct)
import materialsImage from "./resources/Image_MaterialsAndSamples.png";
import experimentsImage from "./resources/Image_Experiments.png";
import fittingImage from "./resources/Image_Fitting.png";
import outputsImage from "./resources/Image_Outputs.png";
import lineshapesImage from "./resources/Image_Lineshapes.png";
import multianalysisImage from "./resources/Image_Multianalysis.png";
import loopImage from "./resources/Image_Loop.png";
import LandingHeader from "./LandingHeader";
import LandingFooter from "./LandingFooter";

const FunctionsLanding = () => {
  const navigate = useNavigate();

  // Scroll to top when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div id="functionsLanding" className="functionsLandingContainer">
      <div className="container py-5">
        {/* Navigation */}
        <LandingHeader />

        <div className="row g-3 extra-large-space"></div>

        {/* Main Header */}
        <div className="text-center mt-5">
          <h1 className="fw-bold" style={{ color: "rgb(31,73,125)" }}>
            app.speqqle{" "}
            <span className="fw-bold" style={{ color: "rgb(0,0,0)" }}>
              has everything you need for the analysis of your spectroscopic
              data!
            </span>
          </h1>
          <p className="text-secondary">
            Are you just starting to learn about spectroscopy or are you already
            an expert? We developed app.speqqle to give you all the tools to
            analyse all your spectroscopy data in one place to get the
            information you need from your data! Here you can find out
            everything app.speqqle can do for you.
          </p>
        </div>

        <div className="text-center mb-5">
          <button
            className="btn btn-lg fw-bold text-white"
            style={{ backgroundColor: "rgb(228,108,10)", borderRadius: "10px" }}
            onClick={() => navigate("/login")}
          >
            Try it out now!
          </button>
        </div>

        <div className="row g-3 extra-large-space"></div>
        <div className="row g-3 extra-large-space"></div>

        {/* Materials & Samples Section */}
        <div className="section-container">
          <div className="section-content">
            <div className="section-image">
              <img
                src={materialsImage}
                alt="Materials & Samples"
                className="img-fluid rounded"
              />
            </div>
            <div className="section-text section-text-left">
              <h2 className="fw-bold text-black">Materials & Samples</h2>
              <p className="text-muted" style={{ fontSize: "0.9rem" }}>
                Is your sample a semiconductor wafer, a coated material, a
                layered stack of paint or complex materials or even a gas?
                <br />
                With app.speqqle you can analyse all your data in one place! It
                supports bulk, multilayer or gas samples. Each component of your
                sample (layer or gas component) is described by a material model
                that describes its optical response.
              </p>
            </div>
          </div>
        </div>

        <div className="row g-3 extra-large-space"></div>
        <div className="row g-3 extra-large-space"></div>

        {/* Experiments Section */}
        <div className="section-container">
          <div className="section-content">
            <div className="section-text section-text-right">
              <h2 className="fw-bold text-black">Experiments</h2>
              <p className="text-muted" style={{ fontSize: "0.9rem" }}>
                With app.speqqle you can analyse data from almost every optical
                spectroscopy technique including:
                <br />
                <br />
                Reflectivity
                <br />
                Transmission
                <br />
                Absorbance
                <br />
                Ellipsometry
                <br />
                Raman
                <br />
                THz time-domain (soon)
                <br />
                SNOM (soon)
              </p>
            </div>
            <div className="section-image">
              <img
                src={experimentsImage}
                alt="Experiments"
                className="img-fluid rounded"
              />
            </div>
          </div>
        </div>

        <div className="row g-3 extra-large-space"></div>
        <div className="row g-3 extra-large-space"></div>

        {/* Fitting Section */}
        <div className="section-container">
          <div className="section-content">
            <div className="section-image">
              <img
                src={fittingImage}
                alt="Fitting"
                className="img-fluid rounded"
              />
            </div>
            <div className="section-text section-text-left">
              <h2 className="fw-bold text-black">Fitting</h2>
              <p className="text-muted" style={{ fontSize: "0.9rem" }}>
                Your data is fitted automatically once you choose the
                experiments you performed. This does not require any coding, but
                is literally only one click away.
              </p>
            </div>
          </div>
        </div>

        <div className="row g-3 extra-large-space"></div>
        <div className="row g-3 extra-large-space"></div>

        {/* Outputs Section */}
        <div className="section-container">
          <div className="section-content">
            <div className="section-text section-text-right">
              <h2 className="fw-bold text-black">Outputs</h2>
              <p className="text-muted" style={{ fontSize: "0.9rem" }}>
                The most important thing about any analysis is the result.
                Optical spectra contain a treasure of information and you can
                choose which outputs you are interested in:
                <br />
                <br />
                Dielectric constant
                <br />
                Refractive index
                <br />
                Loss function
                <br />
                Optical penetration depth
                <br />
                Optical spectral weight
                <br />
                Conductivity
                <br />
                Layer thickness (for multilayer samples)
                <br />
                Temperature (for Raman spectroscopy)
              </p>
            </div>
            <div className="section-image">
              <img
                src={outputsImage}
                alt="Outputs"
                className="img-fluid rounded"
              />
            </div>
          </div>
        </div>

        <div className="row g-3 extra-large-space"></div>
        <div className="row g-3 extra-large-space"></div>

        {/* Lineshapes Section */}
        <div className="section-container">
          <div className="section-content">
            <div className="section-image">
              <img
                src={lineshapesImage}
                alt="Lineshapes"
                className="img-fluid rounded"
              />
            </div>
            <div className="section-text section-text-left">
              <h2 className="fw-bold text-black">Lineshapes</h2>
              <p className="text-muted" style={{ fontSize: "0.9rem" }}>
                If you are a more experienced user, you can choose the
                lineshapes of your fit. At the moment app.speqqle lets you
                select between the following:
                <br />
                <br />
                Drude-Lorentz
                <br />
                Tauc-Lorentz
                <br />
                Fano
              </p>
            </div>
          </div>
        </div>

        <div className="row g-3 extra-large-space"></div>
        <div className="row g-3 extra-large-space"></div>

        {/* Multianalysis Section */}
        <div className="section-container">
          <div className="section-content">
            <div className="section-text section-text-right">
              <h2 className="fw-bold text-black">Multianalysis</h2>
              <p className="text-muted" style={{ fontSize: "0.9rem" }}>
                A special feature of app.speqqle is the multianalysis of more
                than one experiment at the same time. If you have, for example,
                data from an ellipsometry and a transmission experiment on the
                same sample, you can fit both at the same time to increase the
                precision of your result.
              </p>
            </div>
            <div className="section-image">
              <img
                src={multianalysisImage}
                alt="Multianalysis"
                className="img-fluid rounded"
              />
            </div>
          </div>
        </div>

        <div className="row g-3 extra-large-space"></div>
        <div className="row g-3 extra-large-space"></div>

        {/* Loop Section */}
        <div className="section-container">
          <div className="section-content">
            <div className="section-image">
              <img src={loopImage} alt="Loop" className="img-fluid rounded" />
            </div>
            <div className="section-text section-text-left">
              <h2 className="fw-bold text-black">Batch</h2>
              <p className="text-muted" style={{ fontSize: "0.9rem" }}>
                Do you want to analyze not only one spectrum but an entire data
                set? With the batch functionality you can repeat the analysis
                defined for one spectrum for other spectra as many times as you
                like.
              </p>
            </div>
          </div>
        </div>

        <div className="row g-3 extra-large-space"></div>
        <div className="row g-3 extra-large-space"></div>
      </div>
      {/* Footer */}
      <LandingFooter />
    </div>
  );
};

export default FunctionsLanding;
